import React from 'react';
import ReactDOM from 'react-dom';
import Register from './components/Register'
import Login from './components/Login'
import Auth from './components/Auth'
import AuthFreee from './components/AuthFreee'
import AuthGoogle from './components/AuthGoogle'
import GoogleLogin from './components/GoogleLogin'
import { isFreeeLoggedIn, isGoogleLoggedIn } from './utils/AuthService'
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
  Switch
} from 'react-router-dom';
import "./index.scss";

class Root extends React.Component {
  render() {
    return (
      <div className="app">
        <Router>
          <Switch>
            <Route exact path="/" render={() => (
              isFreeeLoggedIn() && isGoogleLoggedIn() ? (
                <Redirect to="/register" />
              ) : (
                  <Login />
                )
            )} />
            <Route
              exact
              path="/auth/freee"
              render={(props) =>
                <AuthFreee location={props.location} />
              }
            />
            <Route
              exact
              path="/googleLogin"
              render={(props) =>
                <GoogleLogin location={props.location} />
              }
            />
            <Route
              exact
              path="/auth/google"
              render={(props) =>
                <AuthGoogle location={props.location} />
              }
            />
            <Auth>
              <Switch>
                <Route exact path="/register" component={Register} />
              </Switch>
            </Auth>
          </Switch>
        </Router>
      </div >
    )
  }
}

export default Root;


ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
